import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-product-availability-notification-confirmation-dialog',
    templateUrl: './product-availability-notification-confirmation-dialog.component.html',
    standalone: false
})
export class ProductAvailabilityNotificationConfirmationDialogComponent {

  @Output() modalCancel: EventEmitter<void> = new EventEmitter();
  @Output() modalYes: EventEmitter<void> = new EventEmitter();
  @Output() modalNo: EventEmitter<void> = new EventEmitter();

  public constructor() {
    this.modalCancel = new EventEmitter<void>();
    this.modalYes = new EventEmitter<void>();
    this.modalNo = new EventEmitter<void>();
  }

  public cancel() {
    this.modalCancel.emit();
  }

  public confirm() {
    this.modalYes.emit();
  }

  public decline() {
    this.modalNo.emit();
  }

}
